import { Component, OnInit, Input } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';
import { TableExporterService } from '../../../services/table-exporter.service';
import * as fileSaver from 'file-saver';

@Component({
	selector: 'app-pratiche-document',
	templateUrl: './pratiche-document.component.html',
	styleUrls: ['./pratiche-document.component.css']
})
export class PraticheDocumentComponent implements OnInit{
	@Input() public row: any = null;
	@Input() writePermission: boolean = false;
	documents: any[] = [];
	praticheSync: Subscription;
	headers: HttpHeaders;

	modalInput: any = {
		size: '',
		title: '',
		subtitle: '',
		data: {
			id: 0,
			crc: 0,
			person: null,
			uid: null,
			id_prat: null,
			reset: false,
		}
	};

	constructor(private dataService: DataService, private tableExporter: TableExporterService) {
		this.headers = new HttpHeaders();
		this.headers.append('Content-Type', 'application/json');
		this.headers.append('Accept', 'application/json');
	}

	ngOnInit() {
		this.praticheSync = this.dataService.pratiche$.subscribe(
			() => {
				this.getDocuments();
			});
	}

	ngOnChanges(changes: any){
		console.log('CHANGE PRATICHE-DOCUMENT', this.row);
		if(changes.row) {
			console.log('CHANGE PRATICHE-DOCUMENT', this.row);
			this.getDocuments();
		}
    }

	getDocuments() {
		this.dataService.getDocumentsByUid(this.row.uid, (documents) => {
			this.documents = documents.reverse();
			for(let document of this.documents){
				document.protocollo_num = Number(document.protocollo_num);
				document.cronologico_num = Number(document.cronologico_num);
			}
			console.log('PRATICHE|ATTI',documents);
		});
	}

	scaricaAtto(row) {
		console.log('SCARICA PRATICA|FILENAME: ',row.nome_file);
		let codiceComune = this.dataService.getComuniService().getComuneCodice();
		let codiceAtto = this.dataService.getStatoCodiceById(row.stato_id);
		let fileName = row.nome_file;
		let codiceGruppo = '';
		let filePath = '';

		this.dataService.getGruppoCodiceByUid(this.row.uid, (codGruppo) => {
			console.log('SCARICA PRATICA|CODICE GRUPPO: ',codGruppo);
			if (codGruppo) {
				codiceGruppo = codGruppo;
				filePath = codiceComune+'/'+codiceGruppo+'/'+codiceAtto;

				let body = JSON.stringify({
					fileName: fileName,
					filePath: filePath
				});
				console.log('SCARICA PRATICA|FILEPATH: ',filePath);

				this.dataService.getAvanzaPraticheService().scaricaPratica(filePath, fileName);
				/*this.dataService.getCommon().getHttpClient().post<any>('/api/downloads/pratica', body,
					{
						//method : RequestMethod.Post,
						//responseType : ResponseContentType.Blob,
						headers: this.headers
					}).subscribe(
						(response) => {
							console.log('SCARICA PRATICA|RESPONSE: ',response);
							let blob = new Blob([response.blob()], {type:'application/zip'});
							fileSaver.saveAs(blob, fileName.split('.')[0]+'.zip');
						}
					);*/
			}else {
				// gestire errore
			}
		});

	}

	aggiungiNotifica() {
		console.log('aggiungi notifica',this.row);
		this.dataService.getDocumentsByUid(this.row.uid, (atti) => {
			let atto: any = {
				id: this.row.id,
				uid: Number(this.row.uid),
				id_prat: this.row.id_prat,
				dataNotifica: null,
				indiceNotifica: null,
				tipoNotifica: null,
			};
			if(atti.length)
				atto = atti[0];

			this.modalInput = {
				size: 'large-modal',
				title: 'Immissione Manuale Notifica',
				subtitle: 'Pratica: ' + this.row.id_prat,
				data: {
					id: this.row.id,
					crc: 0,
					uid: Number(this.row.uid),
					id_prat: this.row.id_prat,
					dataNotifica: atto.notifica_data,
					indiceNotifica: atto.notifica_indice,
					tipoNotifica: atto.notifica_tipo,
					reset: false,
				}
			};
			console.log("apriNotifica", this.modalInput, atto, atti);
		});
	}

	exportData() {
		console.log('export data');
		let filename = 'atti';
		let data = [];
		for (let documento of this.documents) {
			let item = {};
			item['NomeAtto'] = documento.nome_file;
			item['Data Notifica'] = this.dataService.getCommon().getLocale().toLocaleDate(documento.notifica_data);
			item['Num. Protocollo'] = documento.protocollo_num;
			item['Data Protocollo'] = this.dataService.getCommon().getLocale().toLocaleDate(documento.protocollo_data);
			item['Num. Cronologico'] = documento.cronologico_num;
			item['Data Cronologico'] = this.dataService.getCommon().getLocale().toLocaleDate(documento.cronologico_data);
			item['Num. Raccomandata'] = documento.raccomandata_num;
			data.push(item);
		}
		this.tableExporter.toCsv(filename,data);
	}

	ngOnDestroy() {
		this.praticheSync.unsubscribe();
	}
}
